import { useState, useEffect } from 'react';
import { Mail } from 'lucide-react';
import '../../../../styles/contact-modal.css';

interface EmailBlockProps {
  initial?: string;
  onChange: (v: string) => void;
}

export default function EmailBlock({ initial, onChange }: EmailBlockProps) {
  const [email, setEmail] = useState<string>(initial ?? '');
  const [editing, setEditing] = useState<boolean>(Boolean(initial));
  const [type, setType] = useState<'work' | 'home'>('work');

  useEffect(() => {
    setEmail(initial ?? '');
    setEditing(Boolean(initial));
  }, [initial]);

  const handleEmailChange = (newEmail: string) => {
    setEmail(newEmail);
    onChange(newEmail);
  };

  if (!editing) {
    return (
      <div className="cm-box cm-add">
        <button
          style={{ background: 'none', border: 'none', color: '#2563eb', cursor: 'pointer' }}
          onClick={() => {
            setEditing(true);
            setEmail('');
          }}
        >
          + add email
        </button>
      </div>
    );
  }

  return (
    <div className="cm-box">
      <div className="cm-box-left">
        <Mail size={18} className="cm-box-icon" />
        <input
          className="cm-box-input"
          placeholder="example@email.com"
          value={email}
          onChange={(e) => handleEmailChange(e.target.value)}
        />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '12px' }}>
        <select
          value={type}
          onChange={(e) => setType(e.target.value as 'work' | 'home')}
          className="cm-select"
        >
          <option value="work">work</option>
          <option value="home">home</option>
        </select>
        <button
          aria-label="Remove email"
          className="cm-icon-btn"
          onClick={() => {
            setEditing(false);
            setEmail('');
            onChange('');
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}

